import { render, staticRenderFns } from "./Block.vue?vue&type=template&id=f4793c88&scoped=true&"
var script = {}
import style0 from "./Block.scss?vue&type=style&index=0&id=f4793c88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../home/gitlab-runner/.nvm/versions/node/v12.14.1/lib/node_modules/@briskly/vue-cli/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4793c88",
  null
  
)

export default component.exports